import { Box, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Root, classes } from './utils';
import versionColumnDef from './versionColumnDef';
import { lightPalette } from '../../../../theme';
import { getAllVersion } from '../../../../services/versionApi';
import { globalClasses } from '../../utils/globalUtils';
import { getGridFilterSortStatus } from '../../../../services/allInvoiceApi';
import AgGrid from '../../common-components/common-ag-grid/AgGrid';

const Version = () => {
  const paramsData = useParams();
  const [documentName, setDocumentName] = useState('');

  const [gridSettingData, setGridSettingData] = useState({});

  const getFilterSortData = async (id) => {
    try {
      const response = await getGridFilterSortStatus('versions');
      const data = await getAllVersion({}, '', {}, {}, id);
      const parts = data[0]?.invoice?.name;
      setDocumentName(parts);
      setGridSettingData(response);
    } catch (err) {
      return err;
    }
  };

  useEffect(() => {
    getFilterSortData(paramsData?.id);
  }, [paramsData?.id]);

  const isCheckBox = true;

  return (
    <Root className={classes.root}>
      <Box className={classes.versionRoot}>
        <Box
          className={`${globalClasses.displayFlex} ${globalClasses.displayAlignItem} ${classes.versionRootMainBox}`}
        >
          <Typography variant="h4" color={lightPalette.darkPurple.main}>
            Version Details
          </Typography>
          <Typography
            variant="body1"
            className={classes.documentNameOfVersions}
            color={lightPalette.secondaryBlack.main}
          >
            {documentName}
          </Typography>
        </Box>
        <AgGrid
          className={classes.invoiceVersionsAgGridStyle}
          TitleHeader="Versions"
          isCheckBox={isCheckBox}
          functionData={paramsData?.id}
          columnData={versionColumnDef}
          getRowData={getAllVersion}
          gridSettingData={gridSettingData}
          gridKey="versions"
          setGridSettingData={setGridSettingData}
        />
      </Box>
    </Root>
  );
};

export default Version;
